import { Fragment } from "react";
import { Link } from '@mui/material';

import type { RoadmapParent } from "../../api/roadmap-service";

export type RoadmapParentsProps = {
    parents: RoadmapParent[];
    onOpen: (roadmapId: string) => void;
};

/** The roadmaps a roadmap imports, each one opening its own roadmap. */
export function RoadmapParents({ parents, onOpen }: RoadmapParentsProps) {
    return <span data-testid="roadmap-parents">
        Builds on { parents.map((parent, index) => (
            <Fragment key={ parent.id }>
                { index > 0 && ', ' }
                <Link color="inherit" underline="always" sx={ { cursor: 'pointer' } }
                      onClick={ () => onOpen(parent.id) }>{ parent.title }</Link>
            </Fragment>
        )) }
    </span>;
}
